// extracted by mini-css-extract-plugin
export var stepActive = "_23-3";
export var stepCompleted = "_23-4";
export var stepConnectorLine = "_23-b";
export var stepIndicatorCircle = "_23-6";
export var stepIndicatorCircleCompleted = "_23-7";
export var stepIndicatorCircleDefault = "_23-8";
export var stepIndicatorTextCompleted = "_23-9";
export var stepIndicatorTextDefault = "_23-a";
export var stepPending = "_23-5";
export var wizardContainer = "_23-1";
export var wizardContent = "_23-2";
export var wizardModal = "_23-0";